'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record2;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _messageTypes2 = require('../constants/messageTypes');

var _buildUpdates = require('../operators/buildUpdates');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A message that indicates that a CMF has been updated
 *
 * @param {Object} auditParams one of four types of audit with id: SYSTEM_TEST, SYSTEM_MIGRATION, MANUAL, BOT_HANDOFF to indicate the source of this update
 * @param {String} auditParams.id id of either the Bot or the
 * @param {Map} updates a map of message id to updates
 * @param {Map} updates.messageId map of an update of Status and/or messageDeleteStatus
 *
 **/
var MessagesUpdates = function (_Record) {
  _inherits(MessagesUpdates, _Record);

  function MessagesUpdates() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MessagesUpdates);

    return _possibleConstructorReturn(this, (MessagesUpdates.__proto__ || Object.getPrototypeOf(MessagesUpdates)).call(this, {
      updates: (0, _buildUpdates.buildUpdates)(properties),
      auditParams: (0, _immutable.Map)(properties.audit)
    }));
  }

  return MessagesUpdates;
}((0, _immutable.Record)((_Record2 = {}, _defineProperty(_Record2, _messageTypes.MESSAGE_TYPE_ID, _messageTypes2.MESSAGES_UPDATED), _defineProperty(_Record2, 'auditParams', (0, _immutable.Map)()), _defineProperty(_Record2, 'updates', (0, _immutable.Map)()), _Record2), 'MessagesUpdates'));

exports.default = MessagesUpdates;
module.exports = exports['default'];